var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "svg",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 400,
    height: 400,
    viewBox: "0, 0, 400,400",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "svgg"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path0",
    d: "M294.874 23.229 C 292.978 25.275,290.820 31.445,288.224 42.248 C 280.453 74.575,266.352 88.654,233.524 96.863 C 205.890 103.773,205.855 108.931,233.400 115.215 C 265.185 122.466,280.487 137.715,288.258 169.885 C 294.947 197.574,299.795 197.767,306.574 170.614 C 315.120 136.386,328.092 123.537,362.787 114.937 C 377.031 111.406,381.662 109.207,381.662 105.970 C 381.662 102.745,377.724 100.983,361.161 96.796 C 328.083 88.436,315.040 75.191,306.523 41.315 C 301.993 23.297,299.048 18.725,294.874 23.229 M162.350 92.407 C 158.458 96.500,154.722 106.881,150.441 125.501 C 146.670 141.903,142.082 155.121,137.132 163.842 C 119.641 194.659,97.806 209.597,55.874 219.432 C 9.210 230.378,9.637 239.690,57.307 250.694 C 98.521 260.208,123.892 278.534,138.953 309.667 C 144.483 321.098,146.035 325.994,152.147 351.289 C 161.884 391.585,171.344 389.047,181.966 343.288 C 194.331 290.021,221.265 263.096,274.560 250.725 C 323.113 239.454,323.260 230.361,275.072 219.175 C 222.938 207.073,194.551 179.931,183.095 131.232 C 179.302 115.107,178.585 112.295,176.958 107.163 C 172.280 92.411,167.214 87.293,162.350 92.407 ",
    stroke: "none",
    fill: "#000000",
    fillRule: "evenodd"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon);
export default __webpack_public_path__ + "static/media/icon.9bd5d3e5f92635175a47129cebb03e81.svg";
export { ForwardRef as ReactComponent };